import CopyToClipboard from 'components/CopyToClipboard';
import { Typography } from '@mui/material';
import { Code, Header, StyledPaper } from './ThirdPartyCard.styles';

interface ThirdPartyCardProps {
  code: string;
}

const ThirdPartyCard = ({ code }: ThirdPartyCardProps) => (
  <StyledPaper>
    <Header variant="h6">Redemption Code:</Header>
    <Code variant="h4">
      {code} <CopyToClipboard value={code} />
    </Code>
    <Typography variant="h6">
      Apply this code on the checkout page of the Deliveroo app or website
    </Typography>
  </StyledPaper>
);

export default ThirdPartyCard;
